import React from 'react';
import PropTypes from 'prop-types';

import styles from './Notifications-style.scss';

const monthStrings = [
    'January', 'February', 'March', 'April',
    'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
];

const MAX_CHARS_IN_CARD_BODY = 78;

const NotificationCard = props => {
    const {
        thumbnail,
        thumbnailAlt,
        subject,
        actionURL,
        date,
        onClick,
        rightSecondary
    } = props;

    let {
        actionTitle
    } = props;

    if (actionTitle && String(actionTitle).length > MAX_CHARS_IN_CARD_BODY) {
        actionTitle = `${String(actionTitle).substr(0, MAX_CHARS_IN_CARD_BODY)}...`;
    }

    const dateObj = new Date(date);
    const month = dateObj.getMonth();
    const dateNum = dateObj.getDate();
    const dateString = !isNaN(month) && !isNaN(dateNum)
        ? `${monthStrings[month].substr(0, 3)} ${dateNum}`
        : '';
    const detailsSecondary = (actionURL) ? <a href={actionURL}>{actionTitle}</a> : <p>{actionTitle}</p>;

    return (
        <div>
            <div className={styles.row} onClick={onClick}>
                <div className={styles.thumbnail}>
                    <img src={thumbnail} alt={thumbnailAlt} className={styles.thumbnailImage}/>
                </div>
                <div className={styles.details}>
                    <div className={styles.detailsLeft}>
                        <p className={styles.detailsSubject}>{subject}</p>
                        <div className={styles.detailsSecondary}>{detailsSecondary}</div>
                    </div>
                    <div className={styles.detailsRight}>
                        <div>{dateString}</div>
                        {rightSecondary}
                    </div>
                </div>
            </div>
        </div>
    );
};

NotificationCard.propTypes = {
    thumbnail: PropTypes.string.isRequired,
    thumbnailAlt: PropTypes.string,
    subject: PropTypes.string,
    actionTitle: PropTypes.string,
    actionURL: PropTypes.string,
    date: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    rightSecondary: PropTypes.node
};

export default NotificationCard;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationCard.jsx